import { AnyAction } from 'redux'
import { SummaryTopicModel } from '../../api/domain/models/summary-topic-model'
import { SummaryReferenceSourceRatingModel } from '../../api/domain/models/summary-reference-source-rating-model'
import * as actionType from '../actions/types'

export interface SummaryState {
  evttopics:{
    list: SummaryTopicModel[]
    isLoading: boolean
    errorMsg: string
  }
  topics: {
    list: SummaryTopicModel[]
    isLoading: boolean
    errorMsg: string
  }
  referenceSourceRating: {
    list: SummaryReferenceSourceRatingModel[]
    isLoading: boolean
    errorMsg: string
  }
  referenceSourceTopics: {
    list: any[]
    isLoading: boolean
    errorMsg: string
  }
  referenceSourceThemes: {
    list: any[]
    isLoading: boolean
    errorMsg: string
  }
  digest: {
    rubric: {
      list: any[]
      isLoading: boolean
      errorMsg: string
    }
    sphere: {
      list: any[]
      isLoading: boolean
      errorMsg: string
    }
  }
}

const initialState: SummaryState = {
  evttopics: {
    list: [],
    isLoading: true,
    errorMsg: ''
  },
  topics: {
    list: [],
    isLoading: true,
    errorMsg: ''
  },
  referenceSourceRating: {
    list: [],
    isLoading: true,
    errorMsg: ''
  },
  referenceSourceTopics: {
    list: [],
    isLoading: true,
    errorMsg: ''
  },
  referenceSourceThemes: {
    list: [],
    isLoading: true,
    errorMsg: ''
  },
  digest: {
    rubric: {
      list: [],
      isLoading: true,
      errorMsg: ''
    },
    sphere: {
      list: [],
      isLoading: true,
      errorMsg: ''
    }
  }
}

export const summaryReducer = (state = initialState, { type, payload }: AnyAction): SummaryState => {
  switch (type) {
    case actionType.SUMMARY_FETCH_TOPICS_START: {
      return { ...state, topics: { ...state.topics, isLoading: true } }
    }
    case actionType.SUMMARY_FETCH_TOPICS_SUCCESS: {
      return { ...state, topics: { ...state.topics, isLoading: false } }
    }
    case actionType.SUMMARY_FETCH_TOPICS_FAIL: {
      return { ...state, topics: { ...state.topics, isLoading: false, errorMsg: payload } }
    }
    case actionType.SUMMARY_SET_TOPICS_LIST: {
      return { ...state, topics: { ...state.topics, list: payload } }
    }
    case actionType.SUMMARY_FETCH_EVENT_TOPICS_START: {
      return { ...state, evttopics: { ...state.evttopics, isLoading: true } }
    }
    case actionType.SUMMARY_FETCH_EVENT_TOPICS_SUCCESS: {
      return { ...state, evttopics: { ...state.evttopics, isLoading: false } }
    }
    case actionType.SUMMARY_FETCH_EVENT_TOPICS_FAIL: {
      return { ...state, evttopics: { ...state.evttopics, isLoading: false, errorMsg: payload } }
    }
    case actionType.SUMMARY_SET_EVENT_TOPICS_LIST: {
      return { ...state, evttopics: { ...state.evttopics, list: payload } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_START: {
      return { ...state, referenceSourceRating: { ...state.referenceSourceRating, isLoading: true } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_SUCCESS: {
      return { ...state, referenceSourceRating: { ...state.referenceSourceRating, list: payload, isLoading: false } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_FAIL: {
      return { ...state, referenceSourceRating: { ...state.referenceSourceRating, list: [], isLoading: false, errorMsg: payload } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_START: {
      return { ...state, referenceSourceTopics: { ...state.referenceSourceTopics, isLoading: true } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_SUCCESS: {
      return { ...state, referenceSourceTopics: { ...state.referenceSourceTopics, list: payload, isLoading: false } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_FAIL: {
      return { ...state, referenceSourceTopics: { ...state.referenceSourceTopics, list: [], isLoading: false, errorMsg: payload } }
    }

    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_START: {
      return { ...state, referenceSourceThemes: { ...state.referenceSourceThemes, isLoading: true } }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_SUCCESS: {
      return { ...state, referenceSourceThemes: { ...state.referenceSourceThemes, list: payload, isLoading: false } }

      
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_FAIL: {
      return { ...state, referenceSourceThemes: { ...state.referenceSourceThemes, list: [], isLoading: false, errorMsg: payload } }
    }
    
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_START: {
      const digest = {
        rubric: {
          ...state.digest.rubric,
          isLoading: true
        },
        sphere: state.digest.sphere
      }
      return { ...state, digest }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_SUCCESS: {
      const digest = {
        rubric: {
          ...state.digest.rubric,
          list: payload,
          isLoading: false
        },
        sphere: state.digest.sphere
      }
      return { ...state, digest }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_FAIL: {
      const digest = {
        rubric: {
          ...state.digest.rubric,
          list: null,
          isLoading: false,
          errorMsg: payload
        },
        sphere: state.digest.sphere
      }
      // @ts-ignore
      return { ...state, digest }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_START: {
      const digest = {
        sphere: {
          ...state.digest.sphere,
          isLoading: true
        },
        rubric: state.digest.rubric
      }
      return { ...state, digest }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_SUCCESS: {
      const digest = {
        sphere: {
          ...state.digest.sphere,
          list: payload,
          isLoading: false
        },
        rubric: state.digest.rubric
      }
      return { ...state, digest }
    }
    case actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_FAIL: {
      const digest = {
        sphere: {
          ...state.digest.sphere,
          list: null,
          isLoading: false,
          errorMsg: payload
        },
        rubric: state.digest.rubric
      }
      // @ts-ignore
      return { ...state, digest }
    }
    default:
      return state
  }
}
